var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{class:_vm.appClasses},[_c('Toasts'),_c('router-view',{key:_vm.$route.path}),_c('NewContentDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }